import { useState } from 'react'
import { useKiMarker } from '@/core/hooks/useKiMarker'
import type { Dictation } from '@/core/lib/transcribe'

export type DictationInsertion = { next: string; prefix: string }

export function insertDictation(value: string, text: string): DictationInsertion {
  const prefix = value.trim() ? `${value} ` : ''
  return { next: prefix + text, prefix }
}

type LastInsertion = {
  prefix: string
  transkript?: string
  kiErzeugt: boolean
}

export type DictationKi = {
  showKi: boolean
  confirm: () => void
  canUseTranskript: boolean
  takeTranskript: () => void
  onInserted: (insertion: DictationInsertion, dictation: Dictation) => void
}

export function useDictationKi(value: string, onChange: (v: string) => void): DictationKi {
  const [last, setLast] = useState<LastInsertion | null>(null)
  const marker = useKiMarker(last?.kiErzeugt ?? false, value)
  const transkript = last?.transkript?.trim() ?? ''
  const canUseTranskript = marker.showKi && transkript !== ''

  return {
    showKi: marker.showKi,
    confirm: marker.confirm,
    canUseTranskript,
    takeTranskript: () => {
      if (!last || !canUseTranskript) return
      setLast(null)
      onChange(last.prefix + transkript)
    },
    onInserted: (insertion, dictation) => {
      setLast({ prefix: insertion.prefix, transkript: dictation.transkript, kiErzeugt: dictation.ki_erzeugt })
      marker.reset(insertion.next)
    },
  }
}
